import type { ApiMessages } from '../types';

const messages: ApiMessages = {
  'api.label.parameters': '请求参数',
  'api.label.codeSample': '示例代码',
  'api.label.authorization': 'Authorization',
  'api.label.authorization.inheritLabel': '该接口的 Authorization {type} 查看',
  'api.label.authorization.inheritLabel.folder': '从分组[ {folderName} ]继承',
  'api.label.authorization.inheritLabel.project': '从项目继承',

  'api.label.authorization.description.apikey':
    '在 {position} 添加参数 <div class="locals-tag">{key}</div>',
  'api.label.authorization.description.bearer':
    '在 Header 添加参数 <div class="locals-tag">Authorization</div>，其值为在 Bearer 之后拼接 Token',
  'api.label.authorization.description.basic':
    '在 Header 添加参数 <div class="locals-tag">Authorization</div>，其值为在 Basic 之后拼接空格，以及经过 Base64 编码的 {{Username}}:{{Password}}',
  'api.label.authorization.description.digest':
    '在 Header 添加参数 <div class="locals-tag">Authorization</div>，其值为在 Digest 之后拼接摘要加密方案',
  'api.label.authorization.description.hawk':
    '在 Header 添加参数 <div class="locals-tag">Authorization</div>，其值为在 Hawk 之后拼接摘要加密方案',
  'api.label.authorization.description.aws':
    '在 Header 添加参数 <div class="locals-tag">Authorization</div> 和 <div class="locals-tag">X-Amz-Date</div>',
  'api.label.authorization.description.aws.url':
    '在 URL 添加参数 <div class="locals-tag">Authorization</div> 信息和 <div class="locals-tag">X-Amz-Date</div>',
  'api.label.authorization.description.edgegrid':
    '在 Header 添加参数 <div class="locals-tag">Authorization</div>，其值为在 EG1-HMAC-SHA256 之后拼接摘要加密方案',
  'api.label.responses': '返回响应',
  'api.label.example': '示例',
  'api.auth.label.addAuthDataTo': '将Auth数据添加在',
  'api.auth.label.addTo': '添加位置',
  'api.auth.label.more': '更多',
  'api.auth.label.moreTip': '以下为是可选的配置选项，如果留空，{appName} 将自动为字段生成值',
  'api.auth.label.disableRetryRequest': '禁止重试请求',
  'api.auth.label.disableRetryRequestTip':
    '默认情况下，{appName} 将从收到的响应中提取值，将其添加到请求中，然后重试。您要禁用此功能吗?',
  'api.parameterLabel.name': '参数名',
  'api.parameterLabel.value': '参数值',
  'api.parameterLabel.example': '示例值',
  'api.parameterLabel.type': '类型',
  'api.parameterLabel.noNeedToDefineTheBody': '无需定义Body',
  'api.parameterLabel.noNeedToDefineTheResponse': '无需定义返回响应',
  'message.hasNoResponseBody': '该响应没有 Body',
  'api.parameterLabel.file.disabled.tip':
    'Body 为 x-www-form-urlencode 时不支持 file 类型，请改用 form-data',
  'api.status.designing': '设计中',
  'api.status.pending': '待确定',
  'api.status.developing': '开发中',
  'api.status.integrating': '联调中',
  'api.status.testing': '测试中',
  'api.status.tested': '已测完',
  'api.status.released': '已发布',
  'api.status.deprecated': '将废弃',
  'api.status.exception': '有异常',
  'api.status.obsolete': '已废弃',
  'api.automaticGenerated': '自动生成',
  'response.label.headers': 'Headers',
  'response.label.body': 'Body',
  'response.label.contentType': '内容格式',
  'quickDebug.placeHolder.error': 'URL格式不正确 , {detail}',
  'quickDebug.placeHolder.detail': '输入 http 或 https 起始的完整 URL',
  'message.queryParameter': 'Query 参数',
  'message.bodyParameter': 'Body 参数',
  'message.pathParameter': 'Path 参数',
  'message.headerParameter': 'Header 参数',
  'message.cookieParameter': 'Cookie 参数',
  'message.hasNoBodyParameter': '该请求没有 Body 体',
  'api.auth.beginnerTips': '此处添加的 Authorization 会被该分组下所有请求应用，可在具体请求内修改',
  'api.auth.label.type': '类型',
  'parameter.count.none': '无',
  'api.requestBody.binary.uploaded': '已上传文件',
  'api.requestBody.binary.notConfigured': '未设置',
  'api.request.auth.jwt.algorithm.label': '算法',
  'api.request.auth.jwt.secret.label': 'Secret',
  'api.request.auth.jwt.isSecretBase64Encoded.label': 'Secret 是被 Base64 编码过的',
  'api.request.auth.jwt.payload.label': 'Payload',
  'api.request.auth.jwt.headerPrefix.label': 'HTTP Authorization 前缀',
  'api.request.auth.jwt.header.label': '自定义 JWT Header',
  'api.request.auth.jwt.privateKey.label': 'Private Key',
  'api.request.auth.jwt.privateKey.button.label': '选择文件',
  'api.request.auth.jwt.queryParamKey.label': 'Query Param Name',
  'api.request.auth.jwt.algorithm.placeholder': '请选择算法',
  'api.request.auth.jwt.secret.placeholder': 'Secret',
  'api.request.auth.jwt.payload.placeholder': '使用 JSON 撰写',
  'api.request.auth.jwt.headerPrefix.placeholder': 'HTTP Authorization 前缀',
  'api.request.auth.jwt.header.placeholder': '使用 JSON 撰写',
  'api.request.auth.jwt.privateKey.placeholder':
    '-----BEGIN PRIVATE KEY-----\nPrivate Key 使用 PKCS#8 PEM 格式\n-----END PRIVATE KEY-----',
  'api.request.auth.jwt.queryParamKey.placeholder': 'Query Param Name',
  'api.label.authorization.jwt.description1':
    '在 {addTokenTo} 添加参数 <div class="locals-tag">{name}</div>',
  'api.label.authorization.jwt.description2': '，其值为在 {headerPrefix} 之后拼接 Token',

  'api.label.authorization.oauth2.httpAuthorizationPrefix.label': 'HTTP Authorization 前缀',
  'api.label.authorization.oauth2.grantType.label': '授权模式',
  'api.parameterLabel.contentType': 'Content-Type',
  'modified.at.label': '修改于',
  'built.with': 'Built with',
  slogan: 'All-in-one Collaborative API Development Platform',
  'doc.anchor.title': '本篇目录',
  'http.status.code.tooltip': 'HTTP Status Code',
  examples: '示例',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.title': '使用父级默认鉴权值',
  'api.auth.securitySchemeUseCase.valueAssignment.inherit.desc': '使用父级目录配置的默认鉴权值',
  'api.auth.securitySchemeUseCase.valueAssignment.override.title': '手动设置',
  'api.auth.securitySchemeUseCase.valueAssignment.override.desc': '手动设置鉴权需要的信息',
  'api.auth.folderSecuritySchemeUseCase.defaultValue': '默认鉴权值',
  'api.auth.securitySchemeDefinition.more': '和其他 {count} 个',
  'api.auth.securitySchemeDefinition.notToAuth': '不鉴权',
} as const;

export default messages;
